export default __webpack_public_path__ + "static/SSSpyView_screenshot-2@2x-73221da95ae8ef7510e3cd18f0622a86.jpg";